"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var InboxRulesSection_1 = require("./InboxRulesSection");
var getActionClauseTypeOptions_1 = require("../actions/helpers/getActionClauseTypeOptions");
var getConditionalExceptionClauseTypeOptions_1 = require("../actions/helpers/getConditionalExceptionClauseTypeOptions");
var resetInboxRuleEdit_1 = require("../actions/resetInboxRuleEdit");
var setIgnoreSubsequentRules_1 = require("../actions/helpers/setIgnoreSubsequentRules");
var store_1 = require("../store/store");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var React = require("react");
var owa_options_controls_1 = require("owa-options-controls");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var styles = require('./InboxRulesEdit.scss');
var stopProcessingRulesLearnMoreUrl = 'https://support.office.com/en-US/client/results?Shownav=true&lcid=1033&ns=OLWAO365B&version=15&omkt=en-US&ver=15&v=15.20.298.0&mode=Desktop&helpid=ms.exch.owab.InboxRulesStopProcessing';
var InboxRulesEdit = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesEdit, _super);
    function InboxRulesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InboxRulesEdit.prototype.componentWillUnmount = function () {
        resetInboxRuleEdit_1.default();
    };
    InboxRulesEdit.prototype.render = function () {
        var showExceptions = store_1.default.inboxRulesEditState.exceptionClauseIds.length > 0;
        return (React.createElement("div", null,
            this.getInboxRulesSection('name'),
            this.getInboxRulesSection('conditional'),
            this.getInboxRulesSection('action'),
            showExceptions && this.getInboxRulesSection('exception'),
            this.renderIgnoreSubsequentRulesCheckbox()));
    };
    InboxRulesEdit.prototype.getInboxRulesSection = function (sectionType) {
        var editState = store_1.default.inboxRulesEditState;
        switch (sectionType) {
            case 'name':
                return React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 1 });
            case 'conditional':
                return (React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 2, clauseIds: editState.conditionalClauseIds, clauseTypeOptions: getConditionalExceptionClauseTypeOptions_1.default() }));
            case 'action':
                return (React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 3, clauseIds: editState.actionClauseIds, clauseTypeOptions: getActionClauseTypeOptions_1.default() }));
            case 'exception':
                return (React.createElement(InboxRulesSection_1.default, { sectionType: sectionType, numStep: 4, clauseIds: editState.exceptionClauseIds, clauseTypeOptions: getConditionalExceptionClauseTypeOptions_1.default() }));
            default:
                throw new Error('Cannot get inbox rule section component for a section type that does not exist');
        }
    };
    InboxRulesEdit.prototype.renderIgnoreSubsequentRulesCheckbox = function () {
        return (React.createElement("div", { className: styles.ignoreSubsequentRulesCheckbox },
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: store_1.default.inboxRulesEditState.ignoreSubsequentRules, label: owa_options_strings_1.default.options_inboxRules_stopProcessingRules, onChange: function (ev, checked) { return setIgnoreSubsequentRules_1.default(checked); } }),
            React.createElement(Button_1.ActionButton, { className: styles.ignoreSubsequentRulesLearnMore, text: owa_options_strings_1.default.options_inboxRules_learnMore, onClick: function () { return window.open(stopProcessingRulesLearnMoreUrl, '_blank'); } })));
    };
    InboxRulesEdit = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRulesEdit);
    return InboxRulesEdit;
}(React.Component));
exports.default = InboxRulesEdit;
//# sourceMappingURL=InboxRulesEdit.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/InboxRulesEdit.js
// module id = 5183
// module chunks = 2